module.exports = __webpack_public_path__ + "static/media/Multi_Cap.907dfaf6.svg";